var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTableCell',{staticClass:"type-cell",attrs:{"sortable":""}},[_c('BaseStatusBadge',{staticClass:"status-badge",attrs:{"text":_vm.text,"color":_vm.color,"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }